import React, { useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import Checkbox from '../../../../common/Checkbox';
var DeclinePopup = function (_a) {
    var title = _a.title, text = _a.text, onSuccess = _a.onSuccess, onClose = _a.onClose;
    var formRef = useRef();
    var _b = useState(false), error = _b[0], setError = _b[1];
    var declonePopupContainer = document.querySelector('#decline-popup-container');
    var checkFormValidation = function () {
        var _a;
        var isValid = (_a = formRef.current) === null || _a === void 0 ? void 0 : _a.checkValidity();
        setError(!isValid);
        if (isValid) {
            onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
        }
    };
    if (declonePopupContainer) {
        return ReactDOM.createPortal(React.createElement(React.Fragment, null,
            React.createElement("div", { className: "fixed top-0 left-0 w-screen h-screen bg-black opacity-30 z-[100]" }),
            React.createElement("div", { className: "fixed top-[120px] z-[100] w-screen" },
                React.createElement("div", { className: "bg-white rounded-2xl max-w-[588px] mx-auto" },
                    title && (React.createElement("div", { className: "h-16 flex items-center justify-between px-6 border-b border-[#F8FAFE]" },
                        React.createElement("h3", { className: "text-[#252846] font-bold text-[22px]" }, title),
                        React.createElement("div", null,
                            React.createElement("button", { onClick: onClose, className: "h-6 w-6 border text-[#919CC2] border-[#919CC2] rounded flex items-center justify-center" },
                                React.createElement(FontAwesomeIcon, { icon: faXmark, size: "sm" }))))),
                    React.createElement("form", { ref: formRef, className: "flex flex-col gap-6 p-6" },
                        React.createElement("div", { className: "text-left" },
                            React.createElement(Checkbox, { id: "understand_risk", label: text, showError: error })),
                        React.createElement("button", { type: "button", onClick: checkFormValidation, className: "bg-[#FBDFE0] h-10 rounded-lg" },
                            React.createElement("span", { className: "text-sm font-bold text-[#EE7E82]" }, "Continue")))))), declonePopupContainer);
    }
    return null;
};
export default DeclinePopup;
